import { cn as e } from "../shared/utils.js";
import { Checkbox as t } from "../checkbox/primitive/index.js";
import { OverflowProvider as n } from "../shared/overflow/overflow-context.js";
import { useOverflowContainer as r } from "../shared/overflow/use-overflow-container.js";
import { useOverflowItem as i } from "../shared/overflow/use-overflow-item.js";
import { useOverflowMenu as a } from "../shared/overflow/use-overflow-menu.js";
import { ComboboxVirtualizedList as o, ComboboxVirtualizerContext as s, scrollVirtualizedHighlight as c } from "./virtualized-list.js";
import { CheckIcon as l, PlusCircleIcon as u, XCloseIcon as d } from "@systemeio/icons";
import { createContext as f, forwardRef as p, useCallback as m, useContext as h, useId as g, useRef as ee } from "react";
import { Fragment as te, jsx as _, jsxs as v } from "react/jsx-runtime";
import { cva as y } from "class-variance-authority";
import { Field as ne } from "@base-ui/react/field";
import { Combobox as b } from "@base-ui/react/combobox";
//#region src/combobox/combobox-primitive.tsx
var x = f(null), S = f(void 0), C = f(!1);
function w({ max: e, children: t, id: n, onItemHighlighted: r, ...i }) {
	let a = g(), o = n ?? a, l = ee(null), u = ee(null), d = m((e, t) => {
		r?.(e, t), c(u.current, t);
	}, [r]);
	return /* @__PURE__ */ _(S.Provider, {
		value: o,
		children: /* @__PURE__ */ _(x.Provider, {
			value: l,
			children: /* @__PURE__ */ _(s.Provider, {
				value: u,
				children: /* @__PURE__ */ _(C.Provider, {
					value: !!i.multiple,
					children: /* @__PURE__ */ _(b.Root, {
						id: o,
						onItemHighlighted: d,
						...i,
						children: t
					})
				})
			})
		})
	});
}
var T = y([
	"inline-flex shrink-0 items-center gap-1.5 self-center rounded-full bg-palette-blue-bg px-2.5 py-1 text-sm font-normal whitespace-nowrap text-palette-blue-textandicon",
	"outline-none focus:ring-2 focus:ring-field-border-active focus:ring-offset-1",
	"[&>svg:not([class*=size-])]:size-4"
], {
	variants: { variant: {
		tag: "",
		ghost: "bg-transparent text-text-primary"
	} },
	defaultVariants: { variant: "tag" }
}), E = y(["flex size-6 shrink-0 cursor-pointer items-center justify-center rounded-full p-1 -m-1 outline-none [&>svg]:size-4"], {
	variants: { variant: {
		tag: "text-palette-blue-textandicon hover:bg-palette-blue-textandicon/10",
		ghost: "text-text-primary hover:bg-text-primary/10"
	} },
	defaultVariants: { variant: "tag" }
}), D = y([
	"group/combobox-group flex w-full min-w-0 items-center rounded-md border border-field-border bg-field-bg-primary text-text-primary outline-none transition-base text-base",
	"data-[size=md]:px-3 data-[size=sm]:px-2",
	"placeholder:text-text-tertiary",
	"data-popup-open:border-field-border-active data-popup-open:shadow-field-border-active",
	"focus-within:border-field-border-active focus-within:shadow-field-border-active",
	"hover:border-field-border-hover",
	"data-disabled:bg-field-bg-disabled data-disabled:text-text-disabled data-disabled:cursor-not-allowed",
	"data-invalid:border-field-border-error data-invalid:shadow-field-border-error",
	"data-invalid:focus-within:border-field-border-error data-invalid:focus-within:shadow-field-border-error",
	"data-warning:border-border-warning data-warning:shadow-field-border-warning",
	"data-warning:focus-within:border-border-warning data-warning:focus-within:shadow-field-border-warning",
	"data-warning:data-popup-open:border-border-warning data-warning:data-popup-open:shadow-field-border-warning",
	"has-data-[overflow-mode=expanded]:h-auto has-data-[overflow-mode=expanded]:items-start",
	"[&>svg:not([class*=size-])]:size-5"
], {
	variants: { size: {
		sm: "h-8 min-h-8 py-1.5 has-data-[overflow-mode=collapsed]:py-1 has-data-[overflow-mode=expanded]:min-h-8 has-data-[overflow-mode=expanded]:py-[calc(0.25rem-1px)]",
		md: "h-10 min-h-10 py-2.5 has-data-[overflow-mode=collapsed]:py-2 has-data-[overflow-mode=expanded]:min-h-10 has-data-[overflow-mode=expanded]:py-[calc(0.5rem-1px)]"
	} },
	defaultVariants: { size: "md" }
}), O = y("text-text-primary data-placeholder:text-text-tertiary group-data-disabled/combobox-group:text-text-disabled min-w-0 flex-1 px-0.75 text-base", { variants: { element: {
	input: "placeholder:text-text-tertiary group-data-disabled/combobox-group:placeholder:text-text-disabled h-5 border-0 bg-transparent outline-none",
	value: "line-clamp-1 h-5 text-left"
} } }), k = y("text-field-icon group-data-disabled/combobox-group:text-text-disabled flex size-5 shrink-0 items-center justify-center [&>svg]:size-5 [&>svg]:transition-transform [&>svg]:duration-200 [&>svg]:ease-out"), A = p(({ className: t, size: n = "md", ...r }, i) => {
	let a = h(x), o = m((e) => {
		a && (a.current = e), typeof i == "function" ? i(e) : i && (i.current = e);
	}, [a, i]);
	return /* @__PURE__ */ _("div", {
		"data-slot": "combobox-input-group-shell",
		"data-testid": "combobox-input-group-shell",
		"data-size": n,
		className: "relative w-full min-w-0",
		children: /* @__PURE__ */ _(b.InputGroup, {
			ref: o,
			"data-slot": "combobox-input-group",
			"data-testid": "combobox-input-group",
			"data-size": n,
			className: e(D({ size: n }), t),
			...r
		})
	});
}), j = p(({ className: t, ...n }, r) => /* @__PURE__ */ _(b.Input, {
	ref: r,
	"data-slot": "combobox-input",
	"data-testid": "combobox-input",
	className: e(O({ element: "input" }), t),
	...n
})), M = p(({ className: t, ...n }, r) => /* @__PURE__ */ _(b.Trigger, {
	ref: r,
	"data-slot": "combobox-trigger",
	"data-testid": "combobox-trigger",
	className: e(k(), "data-popup-open:[&_svg]:rotate-180", t),
	...n
})), N = p(({ className: t, ...n }, r) => {
	let { children: i, placeholder: a } = n, o = /* @__PURE__ */ _(b.Value, {
		...n,
		children: i
	});
	return typeof i == "function" ? o : /* @__PURE__ */ _("span", {
		ref: r,
		"data-slot": "combobox-value",
		"data-testid": "combobox-value",
		className: e(O({ element: "value" }), t),
		children: o
	});
}), P = p(({ className: t, children: n, ...r }, i) => /* @__PURE__ */ _(b.Clear, {
	ref: i,
	"data-slot": "combobox-clear",
	"data-testid": "combobox-clear",
	className: e("text-field-icon hover:text-icon-primary flex size-5 shrink-0 cursor-pointer items-center justify-center outline-none [&>svg]:size-5", t),
	...r,
	children: n ?? /* @__PURE__ */ _(d, {})
})), re = b.Portal, F = p(({ className: t, sideOffset: n = 4, anchor: r, ...i }, a) => {
	let o = h(x), s = r ?? o?.current ?? void 0;
	return /* @__PURE__ */ _(b.Positioner, {
		ref: a,
		"data-slot": "combobox-positioner",
		"data-testid": "combobox-positioner",
		sideOffset: n,
		anchor: s,
		className: e("z-50 outline-none", t),
		...i
	});
}), I = p(({ className: t, children: n, style: r, ...i }, a) => /* @__PURE__ */ _(b.Popup, {
	ref: a,
	"data-slot": "combobox-popup",
	"data-testid": "combobox-popup",
	style: r,
	className: e("bg-bg-primary text-text-primary border-border-100 shadow-1 rounded-md border py-1 outline-none", "flex max-h-[min(268px,var(--available-height))] w-(--anchor-width) min-w-[160px] flex-col overflow-hidden", "data-starting-style:scale-95 data-starting-style:opacity-0", "data-ending-style:scale-95 data-ending-style:opacity-0", "origin-(--transform-origin) transition-[transform,opacity] duration-100 ease-out", t),
	...i,
	children: n ?? /* @__PURE__ */ _(l, {})
})), L = p(({ className: t, ...n }, r) => /* @__PURE__ */ _(b.List, {
	ref: r,
	"data-slot": "combobox-list",
	"data-testid": "combobox-list",
	className: e("min-h-0 flex-1 overflow-y-auto overscroll-contain", "*:data-[slot='combobox-group']:flex *:data-[slot='combobox-group']:flex-col *:data-[slot='combobox-group']:gap-0", t),
	...n
})), ie = y([
	"group relative flex w-full min-w-0 cursor-pointer flex-row items-center px-4 py-3 text-base outline-none select-none",
	"data-disabled:text-text-disabled data-disabled:cursor-not-allowed",
	"[&>svg:not([class*=size-])]:size-5"
], {
	variants: {
		create: {
			true: "text-text-link gap-1",
			false: "text-text-primary hover:bg-bg-tertiary data-highlighted:bg-bg-tertiary data-selected:bg-bg-accent-light"
		},
		multiple: {
			true: "gap-2",
			false: "gap-1"
		}
	},
	compoundVariants: [{
		create: !0,
		multiple: !0,
		class: "gap-1"
	}],
	defaultVariants: {
		create: !1,
		multiple: !1
	}
}), R = p(({ className: t, render: n, ...r }, i) => {
	let a = h(C);
	return /* @__PURE__ */ _(b.Item, {
		ref: i,
		"data-slot": "combobox-item",
		"data-testid": "combobox-item",
		render: n,
		className: e(!n && ie({ multiple: a }), n && "w-full justify-start", t),
		...r
	});
}), z = p(({ className: t, truncate: n = !0, ...r }, i) => /* @__PURE__ */ _("div", {
	ref: i,
	"data-slot": "combobox-item-text",
	"data-testid": "combobox-item-text",
	className: e("min-w-0 flex-1", "[&_svg:not([class*=size-])]:size-5", n ? "line-clamp-2" : "whitespace-normal", t),
	...r
})), B = p(({ className: t, children: n, ...r }, i) => /* @__PURE__ */ _(b.ItemIndicator, {
	ref: i,
	"data-slot": "combobox-item-indicator",
	"data-testid": "combobox-item-indicator",
	className: e("flex size-5 shrink-0 items-center justify-center [&>svg]:size-5", "transition-opacity duration-150 data-ending-style:opacity-0 data-starting-style:opacity-0", t),
	...r,
	children: n ?? /* @__PURE__ */ _(l, {})
})), V = p(({ className: t, children: n, description: r, ...i }, a) => /* @__PURE__ */ v(b.Empty, {
	ref: a,
	"data-slot": "combobox-empty",
	"data-testid": "combobox-empty",
	className: e("not-empty:flex not-empty:flex-col not-empty:items-start not-empty:gap-1 not-empty:px-3 not-empty:py-4", t),
	...i,
	children: [r != null && r !== "" && /* @__PURE__ */ _("span", {
		"data-slot": "combobox-empty-description",
		"data-testid": "combobox-empty-description",
		className: "text-text-disabled w-full text-sm",
		children: r
	}), n != null && n !== "" && /* @__PURE__ */ _("span", {
		"data-slot": "combobox-empty-title",
		"data-testid": "combobox-empty-title",
		className: "text-text-primary w-full text-base",
		children: n
	})]
})), H = p(({ className: t, ...n }, r) => /* @__PURE__ */ _(b.Group, {
	ref: r,
	"data-slot": "combobox-group",
	"data-testid": "combobox-group",
	className: e("flex flex-col gap-0", t),
	...n
})), U = p(({ className: t, ...n }, r) => /* @__PURE__ */ _(b.GroupLabel, {
	ref: r,
	"data-slot": "combobox-group-label",
	"data-testid": "combobox-group-label",
	className: e("text-text-tertiary flex w-full items-center justify-center pt-3 text-xs font-normal uppercase", t),
	...n
})), W = p(({ className: t, mode: i = "collapsed", padding: a = 4, onKeyDownCapture: o, onBlur: s, ...c }, l) => {
	let u = i === "fixed", d = u || i === "collapsed" ? "collapsed" : "expanded", f = d === "collapsed", { containerRef: p, contextValue: m } = r({ padding: a }), h = (e) => {
		p.current = e, typeof l == "function" ? l(e) : l && (l.current = e);
	}, g = (e) => {
		f && (e.hasAttribute("data-keyboard-chip-nav") || (e.setAttribute("data-keyboard-chip-nav", ""), e.offsetHeight));
	};
	return /* @__PURE__ */ _(n, {
		value: m,
		children: /* @__PURE__ */ _(b.Chips, {
			...c,
			ref: h,
			"data-slot": "combobox-chips",
			"data-testid": "combobox-chips",
			"data-overflow-mode": d,
			"data-multi-layout": u ? "fixed" : void 0,
			className: e("flex min-w-0 flex-1 items-center gap-1", d === "collapsed" ? "flex-nowrap overflow-hidden" : "flex-wrap", t),
			onKeyDownCapture: (e) => {
				if (f) {
					let t = e.target, n = t?.closest?.("[data-slot=\"combobox-input\"]"), r = t?.closest?.("[data-slot=\"combobox-chip\"]");
					(n || r) && (e.key === "ArrowLeft" || e.key === "ArrowRight" || e.key === "Backspace" || e.key === "Delete") && g(e.currentTarget);
				}
				o?.(e);
			},
			onBlur: (e) => {
				f && !e.currentTarget.contains(e.relatedTarget) && e.currentTarget.removeAttribute("data-keyboard-chip-nav"), s?.(e);
			}
		})
	});
}), G = p(({ className: t, variant: n, id: r, ...a }, o) => {
	let s = i(r);
	return /* @__PURE__ */ _(b.Chip, {
		ref: (e) => {
			s.current = e, typeof o == "function" ? o(e) : o && (o.current = e);
		},
		"data-slot": "combobox-chip",
		"data-testid": "combobox-chip",
		"data-variant": n,
		className: e(T({ variant: n }), t),
		...a
	});
});
G.displayName = "ComboboxPrimitive.Chip";
var K = p(({ className: t, variant: n, children: r, ...i }, a) => /* @__PURE__ */ _(b.ChipRemove, {
	ref: a,
	"data-slot": "combobox-chip-remove",
	"data-testid": "combobox-chip-remove",
	"data-variant": n,
	className: e(E({ variant: n }), t),
	...i,
	children: r ?? /* @__PURE__ */ _(d, {})
})), q = p(({ className: t, required: n, ...r }, i) => /* @__PURE__ */ _(b.Label, {
	ref: i,
	"data-slot": "combobox-label",
	"data-testid": "combobox-label",
	"data-required": n || void 0,
	className: e("text-text-secondary data-required:after:text-text-error flex items-start text-base font-normal data-required:after:ml-0.5 data-required:after:content-['*']", t),
	...r
})), J = p(({ className: t, required: n, htmlFor: r, ...i }, a) => {
	let o = h(S);
	return /* @__PURE__ */ _("label", {
		ref: a,
		htmlFor: r ?? o,
		"data-slot": "combobox-input-label",
		"data-testid": "combobox-input-label",
		"data-required": n || void 0,
		className: e("text-text-secondary data-required:after:text-text-error flex items-start text-base font-normal data-required:after:ml-0.5 data-required:after:content-['*']", t),
		...i
	});
}), Y = y("text-base", {
	variants: { tone: {
		default: "text-text-tertiary",
		warning: "text-text-warning"
	} },
	defaultVariants: { tone: "default" }
}), X = p(({ className: t, tone: n, ...r }, i) => /* @__PURE__ */ _("p", {
	ref: i,
	"data-slot": "combobox-description",
	"data-testid": "combobox-description",
	className: e(Y({ tone: n }), t),
	...r
}));
X.displayName = "ComboboxPrimitive.Description";
var Z = p(({ className: t, ...n }, r) => /* @__PURE__ */ _("p", {
	ref: r,
	"data-slot": "combobox-error",
	"data-testid": "combobox-error",
	role: "alert",
	className: e("text-text-error text-base", t),
	...n
}));
Z.displayName = "ComboboxPrimitive.Error";
var ae = p(({ className: t, ...n }, r) => /* @__PURE__ */ _(b.Icon, {
	ref: r,
	"data-slot": "combobox-icon",
	"data-testid": "combobox-icon",
	className: e("text-field-icon flex size-5 shrink-0 items-center justify-center [&>svg]:size-5", t),
	...n
})), oe = p(({ className: t, ...n }, r) => /* @__PURE__ */ _(b.Backdrop, {
	ref: r,
	"data-slot": "combobox-backdrop",
	"data-testid": "combobox-backdrop",
	className: e("bg-alpha-gray-alpha-gray-25 fixed inset-0 z-40 opacity-0 transition-opacity data-open:opacity-100", t),
	...n
})), se = p(({ className: t, ...n }, r) => /* @__PURE__ */ _(b.Status, {
	ref: r,
	"data-slot": "combobox-status",
	"data-testid": "combobox-status",
	className: e("text-text-tertiary px-0.75 py-0.5 text-sm", t),
	...n
})), Q = p(({ className: t, ...n }, r) => /* @__PURE__ */ _(b.Row, {
	ref: r,
	"data-slot": "combobox-row",
	"data-testid": "combobox-row",
	className: e("flex", t),
	...n
})), ce = (e) => /* @__PURE__ */ _(b.Collection, {
	"data-slot": "combobox-collection",
	"data-testid": "combobox-collection",
	...e
}), le = p(({ className: t, ...n }, r) => /* @__PURE__ */ _(b.Separator, {
	ref: r,
	"data-slot": "combobox-separator",
	"data-testid": "combobox-separator",
	className: e("bg-border-100 mx-3 h-px shrink-0", t),
	...n
})), ue = p(({ className: t, children: n, ...r }, i) => /* @__PURE__ */ _("span", {
	ref: i,
	"data-slot": "combobox-leading-icon",
	"data-testid": "combobox-leading-icon",
	"aria-hidden": "true",
	className: e("text-text-tertiary inline-flex size-5 shrink-0 items-center justify-center [&>svg]:size-5", t),
	...r,
	children: n
}));
ue.displayName = "ComboboxPrimitive.LeadingIcon";
var de = p(({ className: n, checked: r = !1, ...i }, a) => /* @__PURE__ */ _(ne.Root, {
	className: "contents",
	children: /* @__PURE__ */ _(t.Root, {
		ref: a,
		"data-slot": "combobox-item-checkbox",
		"data-testid": "combobox-item-checkbox",
		checked: r,
		size: "md",
		tabIndex: -1,
		"aria-hidden": !0,
		className: e("pointer-events-none", n),
		...i,
		children: /* @__PURE__ */ _(t.Indicator, { size: "md" })
	})
}));
de.displayName = "ComboboxPrimitive.ItemCheckbox";
var fe = p(({ className: t, children: n, onClick: r, onMouseDown: i, ...o }, s) => {
	let { ref: c, overflowCount: l, isOverflowing: u } = a(), d = (e) => {
		c.current = e, typeof s == "function" ? s(e) : s && (s.current = e);
	}, f = (e) => {
		e.stopPropagation(), e.preventBaseUIHandler?.();
	}, p = r != null, m = (e) => {
		let t = e.closest("[data-slot=\"combobox-input-group\"]");
		if (!t || t.hasAttribute("data-disabled")) return;
		let n = t.querySelector("[data-slot=\"combobox-input\"]"), r = t.querySelector("[data-slot=\"combobox-trigger\"]");
		if (t.hasAttribute("data-popup-open")) {
			n?.focus();
			return;
		}
		!r || r.disabled || (r.click(), n?.focus());
	}, h = !u;
	return /* @__PURE__ */ _("span", {
		ref: d,
		"data-slot": "combobox-overflow-badge",
		"data-testid": "combobox-overflow-badge",
		"aria-hidden": h || void 0,
		style: h ? { visibility: "hidden" } : void 0,
		onClick: (e) => {
			if (f(e), p) {
				r?.(e);
				return;
			}
			m(e.currentTarget);
		},
		onMouseDown: (e) => {
			f(e), i?.(e);
		},
		className: e("text-text-link inline-flex shrink-0 cursor-pointer items-center gap-0.5 self-center rounded-[48px] px-2 py-1 text-sm font-medium select-none", t),
		...o,
		children: n ?? `+${l}`
	});
});
fe.displayName = "ComboboxPrimitive.OverflowBadge";
var $ = p(({ className: t, children: n, ...r }, i) => /* @__PURE__ */ _("div", {
	ref: i,
	"data-slot": "combobox-popup-action",
	"data-testid": "combobox-popup-action",
	role: "button",
	tabIndex: -1,
	className: e("border-border-100 text-text-link flex min-h-11 w-full cursor-pointer items-center gap-1.5 rounded-md border-t px-3 py-2.5 text-base font-normal outline-none", "hover:bg-button-ghost-color-hover hover:text-text-link-hover", "data-highlighted:bg-button-ghost-color-hover data-highlighted:text-text-link-hover", t),
	...r,
	children: n ?? /* @__PURE__ */ v(te, { children: [/* @__PURE__ */ _(u, { className: "size-5" }), "Button"] })
}));
$.displayName = "ComboboxPrimitive.PopupAction", w.displayName = "ComboboxPrimitive.Root", A.displayName = "ComboboxPrimitive.InputGroup", j.displayName = "ComboboxPrimitive.Input", M.displayName = "ComboboxPrimitive.Trigger", N.displayName = "ComboboxPrimitive.Value", P.displayName = "ComboboxPrimitive.Clear", F.displayName = "ComboboxPrimitive.Positioner", I.displayName = "ComboboxPrimitive.Popup", L.displayName = "ComboboxPrimitive.List", R.displayName = "ComboboxPrimitive.Item", z.displayName = "ComboboxPrimitive.ItemText", B.displayName = "ComboboxPrimitive.ItemIndicator", V.displayName = "ComboboxPrimitive.Empty", H.displayName = "ComboboxPrimitive.Group", U.displayName = "ComboboxPrimitive.GroupLabel", W.displayName = "ComboboxPrimitive.Chips", K.displayName = "ComboboxPrimitive.ChipRemove", q.displayName = "ComboboxPrimitive.Label", J.displayName = "ComboboxPrimitive.InputLabel", ae.displayName = "ComboboxPrimitive.Icon", oe.displayName = "ComboboxPrimitive.Backdrop", se.displayName = "ComboboxPrimitive.Status", Q.displayName = "ComboboxPrimitive.Row", ce.displayName = "ComboboxPrimitive.Collection", le.displayName = "ComboboxPrimitive.Separator";
var pe = {
	Root: w,
	Label: q,
	InputLabel: J,
	Description: X,
	Error: Z,
	InputGroup: A,
	Input: j,
	Trigger: M,
	Value: N,
	Clear: P,
	Icon: ae,
	Portal: re,
	Backdrop: oe,
	Positioner: F,
	Popup: I,
	List: L,
	Status: se,
	Empty: V,
	Item: R,
	ItemText: z,
	ItemIndicator: B,
	Group: H,
	GroupLabel: U,
	Row: Q,
	Collection: ce,
	VirtualizedList: o,
	Chips: W,
	Chip: G,
	ChipRemove: K,
	Separator: le,
	LeadingIcon: ue,
	ItemCheckbox: de,
	OverflowBadge: fe,
	PopupAction: $,
	useFilter: b.useFilter,
	useFilteredItems: b.useFilteredItems
};
//#endregion
export { pe as ComboboxPrimitive, E as comboboxChipRemoveVariants, T as comboboxChipVariants, Y as comboboxDescriptionVariants, O as comboboxFieldTextVariants, D as comboboxInputGroupVariants, ie as comboboxItemVariants, k as comboboxTriggerVisualVariants };
